import { PropsWithChildren } from "react";

export interface ButtonProps {
  color?: "primary" | "secondary";
  rounded?: boolean;
  imageSrc?: string;
  size?: "sm" | "md" | "l" | "xl";
}
function Button({
  children,
  color,
  rounded = false,
  imageSrc,
}: ButtonProps & PropsWithChildren) {
  return (
    <button
      className={`h-8 flex items-center justify-center bg-${color} hover:bg-blue-600 text-white font-semibold py-2 px-4 ${
        rounded ? "rounded-full" : "rounded-none"
      }`}
    >
      {imageSrc && (
        <img
          src={imageSrc}
          alt="Profile"
          className="object-cover w-12 h-12 rounded-full mr-4"
        />
      )}
      <span className="text-xs">{children}</span>
    </button>
  );
}

export default Button;
